attendeeList.component('joinRequestList', {
    bindings: {
        joinRequests: '<',
        isDisabled: '<',
        onRequestAccept: '&',
        onRequestDecline: '&'
    },
    template: [
        'templateCache',
        'helperService',
        function (templateCache, helperService) {
            return templateCache.getTemplate(
                'attendee_list/templates/' + helperService.getRedesignPathPrefix() + 'joinRequestList.html'
            );
        }
    ],
    controller: [
        'helperService',
        'localizationService',
        function (helperService, localizationService) {
            var self = this;

            self.joinRequestDecline = function (joinRequest) {
                self.onRequestDecline({ joinRequest: joinRequest });
            };

            self.joinRequestAccept = function (joinRequest) {
                self.onRequestAccept({ joinRequest: joinRequest });
            };

            // TODO: move to separate component
            self.getJoinRequestInitials = function (joinRequest) {
                return joinRequest && joinRequest.attendeeName
                    ? helperService.getInitialsFromName(joinRequest.attendeeName)
                    : '';
            };

            // TODO: move to separate component
            self.convertContactDataToColorClass = function (joinRequest) {
                return helperService.convertContactDataToColorClass(joinRequest.id, joinRequest.attendeeName);
            };

            self.getAcceptTooltipText = function () {
                return self.isDisabled
                    ? localizationService.translate('COMMON.CONNECTING')
                    : localizationService.translate('COMMON.ACCEPT');
            };

            self.getDeclinedTooltipText = function () {
                return self.isDisabled
                    ? localizationService.translate('COMMON.CONNECTING')
                    : localizationService.translate('COMMON.DECLINE');
            };
        }
    ]
});
